var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5943 92H33V31.9948H47.1734V34.0863H35.0915V89.9085H83.5028V34.0863H71.4209V31.9948H85.5943V92Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4664 38.081H46.1274V31.2209C46.1274 29.4431 47.5706 28 49.3484 28H69.2455C71.0233 28 72.4664 29.4431 72.4664 31.2209V38.081ZM48.2189 35.9895H70.3749V31.2209C70.3749 30.6004 69.866 30.0915 69.2455 30.0915H49.3484C48.7279 30.0915 48.2189 30.6004 48.2189 31.2209V35.9895Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5562 60.9551H41.0869V47.4858H54.5562V60.9551ZM43.1784 58.8636H52.4647V49.5773H43.1784V58.8636Z",
    fill: "#2DCDAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8106 57.8178L43.8477 54.8549L45.3257 53.3769L46.8106 54.8619L50.3243 51.3551L51.8023 52.8331L46.8106 57.8178Z",
    fill: "#2DCDAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4613 53.1747H58.7881V55.2662H76.4613V53.1747Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5562 81.2985H41.0869V67.8292H54.5562V81.2985ZM43.1784 79.207H52.4647V69.9207H43.1784V79.207Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4613 73.5181H58.7881V75.6096H76.4613V73.5181Z",
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesIcon);
export default __webpack_public_path__ + "static/media/guidesIcon.3315e859c7a114a81383856ae2e2fd0d.svg";
export { ForwardRef as ReactComponent };